import React from 'react'
import { createRoot } from "react-dom/client";
import { App } from '@/components/app'

document.addEventListener('DOMContentLoaded', () => {
    document.fonts.ready.then(() => {
    const app = createRoot(document.getElementById("app"))
    app.render(<App />)
  })
})
